module.exports = __webpack_public_path__ + "static/media/spotify.80e6bf82.svg";